import { http } from './request';

/**
 * 获取所有分类
 */
export const GetCategoryList = () => {
    return http.post('Shop/GetCategoryList');
};

/**
 * 询价
 */
export const Inquiry = data => {
    return http.post('Shop/Inquiry', data);
};

/**
 * 快速询价
 */
export const QuickInquiry = SkuID => {
    return http.get('Shop/QuickInquiry', {
        params: {
            SkuID: SkuID
        }
    });
};

/**
 * 登出
 */
export const Logout = () => {
    return http.post('SeekerBase/Logout');
};

/**
 * 登录
 */
export const LoginValidateForPortal = data => {
    return http.post('SeekerBase/LoginValidateForPortal', data);
};

/**
 * 根据sku获取商品详情
 */
export const GetProductSKUInPortal = sku => {
    return http.post('Shop/GetProductSKUInPortal?sku=' + sku);
};

/**
 * 搜索
 */
export const GetProductSKUListInPortal = data => {
    return http.post('Shop/GetProductSKUListInPortal', data);
};

/**
 * 首页接口
 */
export const IndexApi = {
    /**
     * 获取所有分类
     */
    GetAllCategory: () => {
        return http.post('Shop/GetAllCategory');
    },
    /**
     * 根据品牌或者分类获取产品SKU
     */
    GetProductSKUByCategory: (categoryID, brandID) => {
        return http.post('Shop/GetProductSKUByCategory?categoryID=' + categoryID + '&brandID=' + brandID);
    }
};

/**
 * 订单接口
 */
export const OrderApi = {
    /**
     * 取消订单
     */
    CancelOrder: orderID => {
        return http.get('Shop/CancelOrder', {
            params: {
                orderID: orderID
            }
        });
    },
    GetOrderListInPortal: data => {
        return http.post('Shop/GetOrderListInPortal', data);
    },
    submitOrder: data => {
        return http.post('Shop/submitOrder', data);
    }
};

/**
 * 购物车
 */
export const ShopCartApi = {
    /**
     * 添加购物车
     */
    AddToShoppingCart: (SkuId, Count) => {
        return http.get('Shop/AddToShoppingCart', {
            params: {
                SkuId: SkuId,
                Count: Count
            }
        });
    },
    /**
     * 购物车更新数量
     */
    UpdateShoppingCartNum: (id, count) => {
        return http.get('Shop/UpdateShoppingCartNum', {
            params: {
                id: id,
                count: count
            }
        });
    },
    /**
     * 删除购物车商品
     */
    ShoppingCartRemove: ids => {
        return http.post('Shop/ShoppingCartRemove', ids);
    },
    /**
     * 获取成本中心列表
     */
    GetCostCenterListInProtal: () => {
        return http.post('Shop/GetCostCenterListInProtal');
    },
    /**
     * 获取我的购物车
     */
    MyShopShoppingCart: () => {
        return http.post('Shop/MyShopShoppingCart');
    }
};

export const InquiryOrderApi = {
    AddToInquirySheet: skuid => {
        return http.post('Shop/AddToInquirySheet?SkuID=' + skuid);
    },
    GetInquirySheetInCart: () => {
        return http.post('Shop/GetInquirySheetInCart');
    },
    InquirySheetRemove: ids => {
        return http.post('Shop/InquirySheetRemove', ids);
    },
    SubmitIsmpInquiry: body => {
        return http.post('Shop/SubmitIsmpInquiry', body);
    }
};

export const InquiryOrderListApi = {
    GetInquirySheetList: () => {
        return http.post('Shop/GetInquirySheetList');
    }
};
